import React, { useState} from 'react';
import firebase from 'firebase/app';
import { connect } from 'react-redux';
import { withRouter, NavLink } from 'react-router-dom';

//style
import { LockClosedIcon } from '@heroicons/react/solid';

//logo
import logo from '../../../../../images/bound_bleu_logo.png';

const ResetPassword = () => {

    const [ email, setEmail ] = useState()
    const [ showMsg, setShowMsg] = useState(false)

    const handleClick = (email) => {
        var auth = firebase.auth();
        var emailAddress = email;

        auth.sendPasswordResetEmail(emailAddress).then(function() {
        // Email sent.
        setShowMsg(true)
        }).catch(function(error) {
        // An error happened.
        });
    }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <img
            className="mx-auto h-12 w-auto"
            src={logo}
            alt="Bound"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">Reset your password</h2>
        </div>
        {/* <form className="mt-8 space-y-6" action="#" method="POST"> */}
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email-address" className="sr-only">
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Email address"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center">
                {!showMsg ? 
                    <div
                    className="text-sm"
                    style={{
                        marginTop: '10px'
                    }}>
                        <NavLink
                        className="font-medium text-indigo-600 hover:text-indigo-500"
                        exact
                        to='/signIn'
                        >
                            {`Back to login`}
                        </NavLink>
                    </div>
                :
                    <div
                    className="text-sm"
                    style={{
                        marginTop: '10px'
                    }}>
                        <p style={{color: 'red', fontSize:'20px', marginBottom: '10px'}}>Email was just sent, please check your inbox</p>  
                        <NavLink
                        className="font-medium text-indigo-600 hover:text-indigo-500"
                        exact
                        to='/signIn'
                        >
                            {` Return to Login`}
                        </NavLink>
                    </div>
                }
            </div>
          </div>
          <div>
            <button
                type="submit"
                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                onClick={() =>handleClick(email)}
            >
              <span className="absolute left-0 inset-y-0 flex items-center pl-3">
                <LockClosedIcon className="h-5 w-5 text-indigo-500 group-hover:text-indigo-400" aria-hidden="true" />
              </span>
              Reset
            </button>
          </div>
        {/* </form> */}
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
    return {
        authError: state.auth.authError,
        auth: state.firebase.auth
    }
}

export default withRouter(connect(mapStateToProps, null)(ResetPassword))